import SVGIconWrapper from "./SVGIconWrapper"

const IconStar = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 250 238.25"
        iconClass={`icon--star ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M199.16 238.25a5 5 0 0 1-2.72-.8L125 191.21l-71.45 46.24A5 5 0 0 1 46 232l21.9-82.24L1.85 96.07a5 5 0 0 1 2.88-8.87l85-4.58L120.34 3.2a5 5 0 0 1 9.33 0l30.62 79.41 85 4.58a5 5 0 0 1 2.88 8.87l-66.06 53.66L204 232a5 5 0 0 1-4.83 6.29zm-74.16-58a5 5 0 0 1 2.72.8L191 222l-19.4-72.84a5 5 0 0 1 1.68-5.17l58.51-47.53-75.27-4.06a5 5 0 0 1-4.4-3.19L125 18.9 97.88 89.23a5 5 0 0 1-4.4 3.19l-75.26 4.06L76.72 144a5 5 0 0 1 1.68 5.17L59 222l63.28-41a5 5 0 0 1 2.72-.75z" />
    </SVGIconWrapper>
)

export default IconStar